import React, { FC } from "react";
import {Row, Col} from 'antd';
import ImageSlider from "./imageSlider";

import "./auth.scss";

export type LayoutProps = {
  children: React.ReactNode;
  className?: string;
};

const Layout: FC<LayoutProps> = ({ children, className }: LayoutProps) => {
  return (
    <div className={`auth-layout ${className}`}>
      <div className="container">
        <Row>
          <Col span={14} style={{ paddingLeft: 0 }}>
            <div className="auth-banner"><ImageSlider /></div>
          </Col>
          <Col span={10} className="m-auto">
            <Row>
              <Col span={24}>
                <div className="auth-wrap">
                  {children}

                  <div className="auth-copy">
                    <div>
                    <span className="logo small"></span>
                    <span className="clr-n50" style={{ margin: "0 8px" }}>
                      |
                    </span>
                    <span className="clr-n75">
                      Copyrights HealthEM.AI {new Date().getFullYear()}
                    </span>
                    </div>
                    <div>
                      <span className="clr-n75">
                        For any security related concerns, please contact 
                      </span>
                      <span className="ml-1">
                        &nbsp;
                        <a href="mailto://support.healthem@tredence.com">
                          support.healthem@tredence.com
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Layout;